export const LOGO_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_geofence-attendance-9/artifacts/coaygetc_Branding%20BT_LogoText%20No%20Website_White.webp";

export const BRAND = {
  name: "BT Control Room",
  subtitle: "Attendance",
  fullName: "BT Control Room",
};
